import { render, staticRenderFns } from "./EditKisok.vue?vue&type=template&id=b30f7af4"
import script from "./EditKisok.vue?vue&type=script&lang=js"
export * from "./EditKisok.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports